import React from 'react';
import { InputCheckbox } from '@isyc-react/form/modules/input/option/checkbox';
import "./table-checkbox.style.scss";
export const TableCheckbox = props => {
  const {
    indeterminate,
    onChange,
    checked,
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "table-checkbox-container"
  }, /*#__PURE__*/React.createElement(InputCheckbox, {
    value: {
      indeterminate,
      checked: Boolean(checked)
    },
    onChange: change => {
      onChange && onChange({
        target: change
      });
    },
    children: children
  }));
};